import PropTypes from "prop-types";
import React from "react";

import { testLocator } from "../../../lib/helpers/test-locator";

import "./styles.scss";

export const FormFieldError = ({ children, otherErrors = [], testId }) => {
  return (
    <p className="FormFieldError-text" data-public {...testLocator(testId)}>
      {children ?? (otherErrors.length > 0 && otherErrors[0])}
    </p>
  );
};

FormFieldError.propTypes = {
  children: PropTypes.string,
  testId: PropTypes.string,
};
